import { generatePath, useLoaderData, useNavigate, useParams } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams';
import { omaElisaForCompaniesMsg, orderMsg, t } from '../../../../../common/i18n/index.js';
import { DeliveryOrderDetails } from '../../../../../components/DeliveryOrderDetails/DeliveryOrderDetails.js';
import type { DeliveryId, OrderId } from '../../../../../common/constants/pathInterfaces.js';
import type { DeliveryOrderLoaderData } from '../../../../../common/loaders';

export const CustomerOrderProductPath = () => {
  const navigate = useNavigate();
  const { orderId, deliveryId } = useParams<OrderId & DeliveryId>();
  const { mdmId } = useSearchParams<{ mdmId: string }>();
  const { customerOrder } = useLoaderData() as DeliveryOrderLoaderData;
  const deliveryOrder = customerOrder.deliveryOrders.find(e => e.deliveryOrderDisplayId === deliveryId);

  if (customerOrder && deliveryOrder) {
    return (
      <DeliveryOrderDetails
        customerOrder={customerOrder}
        deliveryOrder={deliveryOrder}
        onClickCustomerOrder={() => {
          navigate(`${generatePath(paths.CUSTOMER_ORDER, { orderId: orderId! })}?mdmId=${mdmId}`);
        }}
        breadCrumbPaths={[
          { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
          { name: t.I9C0(orderMsg), path: paths.CUSTOMER_ORDERS },
          {
            name: customerOrder.customerOrderDisplayId,
            path: `${generatePath(paths.CUSTOMER_ORDER, { orderId: orderId! })}?mdmId=${mdmId}`,
          },
          { name: deliveryOrder.deliveryOrderName },
        ]}
        mdmId={mdmId}
        isApprover={true}
      />
    );
  }
  return null;
};
